<template>
  <div>
    <order-file-tab-nav></order-file-tab-nav>

    <!--タブのコンテンツ部分-->
    <div class="tab-content" v-scrollbar>
      <order-file-tab-menu></order-file-tab-menu>

      <div class="file_content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import OrderFileTabNav from "../../../components/OrderFileTabNav.vue";
import OrderFileTabMenu from "../../../components/OrderFileTabMenu.vue";

export default {
  components: {
    OrderFileTabNav,
    OrderFileTabMenu
  }
};
</script>
